export default __webpack_public_path__ + "static/media/cs_icon_03_on.fbb92973.png";